import React from 'react';
import styled, { useTheme } from 'styled-components';
// import GaugeChart from 'react-gauge-chart';
import GaugeComponent from 'react-gauge-component';

import { GaugeMeterProps } from 'sharedComponents/inputGroup/InputInterface';

const GaugeContainer = styled.div`
  text-align: center;
`;

const ScoreText = styled.div`
  font-size: 20px;
  margin-top: -90px;
  font-weight: 300;
`;

const SubText = styled.div`
  font-size: 35px;
  color: ${(props) => {
    if (props.status === "EXCELLENT") return "#00C853";
    if (props.status === "GOOD") return "#64DD17";
    if (props.status === "FAIR") return "#FFD600";
    if (props.status === "POOR") return "#FF6D00";
    return "#D50000";
  }};
  font-weight: 700;
  line-height: 1;
`;

// const DabaduGaugeChart = styled(GaugeComponent)``;
export const GaugeMeter: React.FC<GaugeMeterProps> = ({ value }) => {
  // const theme = useTheme();

  const GAUGE_CHART_PROPS = {
    type: 'semicircle',
    id: 'gauge-component4',
    minValue: 300,
    maxValue: 900,
    arc: {
      padding: 0.005,
      cornerRadius: 1,
      width: 0.12,
      subArcs: [
        {
          limit: 300,
          color: '#FF0000',
          showTick: true,
        },
        {
          limit: 450,
          color: '#FF0000',
          showTick: true,
        },
        {
          limit: 580,
          color: '#FF5600',
          showTick: true,
        },
        {
          limit: 670,
          color: '#FFC900',
          showTick: true,
        },
        {
          limit: 740,
          color: '#8BCF00',
          showTick: true,
        },
        {
          limit: 900,
          color: '#00D000',
          showTick: true,
        },
      ],
    },
    labels: {
      valueLabel: {
        formatTextValue: (value) => value,
        // matchColorWithArc: true,
        style: {
          transform: 'translate(0, -30px)',
          fontSize: '50px',
          fill: '#000',
          textShadow: 'none',
          fontWeight: '800',
        },
      },
    },
    pointer: {type: "blob", animationDelay: 0 }
  };

  const getScoreStatus = (value) => {
    if (value >= 740) {
      return "EXCELLENT";
    }
    if (value >= 670) {
      return "GOOD";
    }
    if (value >= 580) {
      return "FAIR";
    }
    if (value >= 450) {
      return "POOR";
    }
    return "VERY POOR";
  };

  const scoreStatus = getScoreStatus(value);

  return (
    <GaugeContainer>
      <GaugeComponent {...GAUGE_CHART_PROPS} value={value} />
      <ScoreText>Your score is</ScoreText>
      <SubText status={scoreStatus}>{scoreStatus}</SubText>
    </GaugeContainer>
  );
};
